export default "__VITE_ASSET__DIHazRf2__"